<template>
  <div>
    <div class="ucar-mask" v-if="supportTouchmove">
      <slot></slot>
    </div>
    <div class="ucar-mask" v-else @touchmove.stop.prevent>
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.ucar-mask {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;
}
</style>

<script>
export default {
  props: {
    supportTouchmove: {
      type: Boolean,
      default: false
    }
  }
}
</script>
